import { FC } from "react";
import Alert from "@cloudscape-design/components/alert";
import UserProfileEntity from "../../../../../../domain/entities/UserProfileEntity";

interface MissingDataBannerProps {
    profile: UserProfileEntity;
}

const MissingDataBanner: FC<MissingDataBannerProps> = ({ profile }) => {
    const missingFields: string[] = [];

    if (!profile.bucket_path || profile.bucket_path.length === 0) {
        missingFields.push("No bucket assigned");
    }

    if (!profile.business_unit) {
        missingFields.push("No business unit assigned");
    }

    if (!profile.position) {
        missingFields.push("No position assigned");
    }

    if (missingFields.length === 0) {
        return null;
    }

    return (
        <Alert type="warning">
            {missingFields.join("; ")}
        </Alert>
    );
};

export default MissingDataBanner;
